import { render, staticRenderFns } from "./CreateGroupEvaluationDialog.vue?vue&type=template&id=db27246a&scoped=true"
import script from "./CreateGroupEvaluationDialog.vue?vue&type=script&lang=js"
export * from "./CreateGroupEvaluationDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateGroupEvaluationDialog.vue?vue&type=style&index=0&id=db27246a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db27246a",
  null
  
)

export default component.exports